import { Component, OnInit, OnDestroy } from "@angular/core";
import { ContactDialogService } from "../contact-dialog";
import { ContactService } from "src/app/services";
import { Subscription } from "rxjs";

import { webContactDefault, ContactWeb } from "src/app/models";

@Component({
  selector: "app-contact-list",
  templateUrl: "./contact-list.component.html",
  styleUrls: ["./contact-list.component.scss"]
})
export class ContactListComponent implements OnInit, OnDestroy
{

  contactsSubscription: Subscription;
  contacts: Array<ContactWeb> = [];

  constructor(
    private contactDialogService: ContactDialogService,
    private contactService: ContactService
  )
  {

  }

  ngOnInit()
  {
    this.contactsSubscription = this.contactService.contacts.subscribe(c => this.contacts = c);
  }

  ngOnDestroy()
  {
    this.contactsSubscription.unsubscribe();
  }

  handleAddClick(): void
  {
    const contact = { ...webContactDefault };
    this.contactDialogService.openDialog(contact);
  }
}
